/**
 * @file loadingHelpers.js
 * @fileOverview React loading screen manager
 * @author Smartmatic
 * @creationDate 2019-11-14
 * @modificationDate 2025-03-14
 */
import React from 'react';
// import LandingSkeleton from "./../pages/LandingSkeleton";
// import BallotSkeleton from "./../pages/Ballot/BallotSkeleton";
import HeaderSkeleton from '../components/HeaderSkeleton';
import { getItem } from './PrivacyManager';
import { IS_IE } from './detectBrowser';
import Copy from './CopyManager';

const LOADING_TEXT = {
  EN: 'Loading',
  ES: 'Cargando',
  ZH: '載入中',
  JA: '読み込み中',
  KO: '로딩',
  VI: 'Tải',
  TL: 'Naglo-Load',
  HI: 'लोड हो रहा है',
  KM: 'ផ្ទុក',
  TH: 'โหลด',
  HY: 'բեռնում',
  FA: 'بارگذاری', //make sure rtl with ... ?
  RU: 'погрузка',
};

/**
 * Renders a dynamic loading screen based on the provided path parameter.
 *
 * This function determines the layout and content of the loading screen depending on the
 * specified path. If no matching path is found, the function creates a div with a unique
 * style and potential IE 11 optimization. The language and message displayed in the div
 * depend on the 'selectedLanguage' item stored in local storage. The value of
 * 'withHeaderSkeleton' determines whether 'HeaderSkeleton' component is displayed.
 *
 * @param {string} path - The route to match and determine which screen should be displayed.
 * @param {boolean} [withHeaderSkeleton=false] - Control whether or not to show the 'HeaderSkeleton' on the screen.
 * @returns {object} The constructed JSX Element for rendering in a React application.
 */
export function getLoadingScreen(path, withHeaderSkeleton) {
  let body;
  const isRTL = getItem('selectedLanguage', 'EN') === 'FA' || getItem('selectedLanguage', 'EN') === 'AR';
  switch (path) {
    // case "/":
    //   body = <LandingSkeleton />;
    //   break;
    // case "/ballot":
    //   body = <BallotSkeleton />;
    //   break;
    default:
      body = (
        <div
          /* A lot of this CSS is needed for proper layout in IE 11 */
          style={{
            width: '100vw',
            textAlign: 'center',
            margin: '50vh auto',
            direction: isRTL ? 'rtl' : 'ltr',
          }}
        >
          {IS_IE && Copy(undefined, 'ISB', getItem('selectedLanguage', 'EN')).zuc}
          {!IS_IE && LOADING_TEXT[getItem('selectedLanguage', 'EN')]}...
        </div>
      );
  }

  return (
    <>
      {withHeaderSkeleton && <HeaderSkeleton />}
      {body}
    </>
  );
}
